import createListStore from "../stores/listStoreFactory";

export const useUserStore = createListStore('user', )

export default useUserStore